import { Cookies } from 'quasar';
import { axiosInstance } from 'boot/axios.js';
import i18n from 'src/i18n/index.js';
import { parseJwt } from 'src/utils/helpers';
import Notify from 'src/constants/notify';

export default ({ store, router }) => {
  axiosInstance.interceptors.request.use((request) => {
    const controller = new AbortController();
    const token = Cookies.get('authorization_token');
    const localExpirationTime = Cookies.get('authorization_token_local_expiration_time');
    if (token) {
      const parsedToken = parseJwt(token);
      const expirationDateTime = new Date(parsedToken.exp * 1000);

      // Using the local expiration time we calculated instead of expiration time of token.
      // The local time can differ from server time this is why we use the calculated local expiration time.
      const localExpirationDate = !isNaN(localExpirationTime)
        ? new Date(parseInt(localExpirationTime))
        : expirationDateTime;

      if (new Date() >= localExpirationDate) {
        Notify.create({
          progress: false,
          type: 'negative',
          message: i18n.global.t('response.status-code-401'),
        });
        setTimeout(() => {
          router.push({ name: 'logout' });
        }, 3000);
        controller.abort(i18n.global.t('response.status-code-401'));
      }
    }
    return {
      ...request,
      signal: controller.signal,
    };
  });

  axiosInstance.interceptors.response.use(
    (response) => {
      if (response.data.loginToken !== undefined) {
        handleLoginToken(store, response);
      }
      if (response.data.accessToken !== undefined) {
        handleAccessToken(store, response);
      }
      store.commit('auth/setIsAccountTemporaryBlocked', undefined);

      return response;
    },
    (error) => {
      let message;
      let showProgress = false;
      let hasPriority = false;

      if (error.response && error.response.status) {
        switch (error.response.status) {
          case 401:
            showProgress = true;
            setTimeout(() => {
              router.push({ name: 'logout' });
            }, 5000);
            message = i18n.global.t('response.status-code-401');
            hasPriority = true;
            break;

          case 403:
            showProgress = true;
            setTimeout(() => {
              router.push({ name: 'logout' });
            }, 5000);
            message = i18n.global.t('response.status-code-403');
            hasPriority = true;
            break;

          case 500:
            message = i18n.global.t('response.status-code-500');
            break;

          case 423:
            store.commit('auth/setIsAccountTemporaryBlocked', error.response.data);
            break;

          default:
            message = i18n.global.t('response.default-error', {
              error: error.response.status,
            });
            break;
        }
        setTimeout(() => {
          const urls = store.getters['notification/notificationRequestUrls'];
          const requestUrl = error.response.config.url;
          if ((hasPriority || !urls.includes(requestUrl)) && message) {
            Notify.create({
              progress: showProgress,
              message: message,
              type: 'negative',
            });
          }
          store.dispatch('notification/clearNotificationRequestUrl', requestUrl);
        }, 50);
      }

      return Promise.reject(error);
    },
  );
};
function handleLoginToken(store, response) {
  store.dispatch('auth/getVerification', response.data.loginToken);
  axiosInstance.defaults.headers.common.Authorization = 'Bearer ' + response.data.loginToken;
}
function handleAccessToken(store, response) {
  store.dispatch('auth/parseTokenSetUser', response.data.accessToken);
  store.dispatch('auth/setToken', {
    token: response.data.accessToken,
    rememberMe: store.state.rememberMe,
  });
}
